export const SET_FINANCIAL_DATA = 'SET_FINANCIAL_DATA';
export const SET_SINGLE_FINANCIAL_DATA = 'SET_SINGLE_FINANCIAL_DATA';
export const ADD_FINANCIAL_DATA = 'ADD_FINANCIAL_DATA';
export const DELETE_FINANCIAL_DATA = 'DELETE_FINANCIAL_DATA';



// WEBPACK FOOTER //
// ./src/store/modules/financial/action-types.js